import React, { useState, useRef } from 'react';
import ContextMenu from './Overlays/ContextMenu';
import Icon from './Icon';

export default function CaretButton({ items = [], editor, title = 'Options', placement = 'top' }) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef();
  const wrapperRef = useRef();
  const _lastTouchRef = useRef(false);

  const activeItem = items.find(it => typeof it.isActive === 'function' && it.isActive(editor));
  const rawMainIcon = activeItem ? activeItem.iconClass : (items[0] ? items[0].iconClass : 'dots-three');
  const normalizedMainIcon = String(rawMainIcon || '')
    .replace(/^ph[ -]?/, '')
    .trim();
  const [mainIconName, ...mainIconClasses] = normalizedMainIcon.split(/\s+/).filter(Boolean);
  const isActive = Boolean(activeItem);

  const menuItems = items.map(it => {
    const m = typeof it.label === 'string' && it.label.match(/^H(\d)$/i);
    const label = m ? `Header ${m[1]}` : it.label;
    return {
      label,
      iconClass: it.iconClass,
      onClick: (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        try { it.onClick(e); } catch (err) {}
        setOpen(false);
      },
      isActive: typeof it.isActive === 'function' ? !!it.isActive(editor) : false,
    };
  });

  const btn = (
    <div ref={wrapperRef} className="caretWrapper" style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        ref={triggerRef}
        className={`caretButton ${isActive ? 'active' : ''}`}
        data-context-placement={placement}
        onPointerDown={e => { if (e && e.pointerType === 'mouse') e.preventDefault(); }}
        onPointerUp={e => {
          if (e && e.pointerType && e.pointerType !== 'mouse') {
            e.preventDefault?.();
            _lastTouchRef.current = true;
            setOpen(o => !o);
            // reset flag after short delay to avoid blocking unrelated clicks
            setTimeout(() => { _lastTouchRef.current = false; }, 350);
          }
        }}
        onClick={(e) => { if (_lastTouchRef.current) { _lastTouchRef.current = false; return; } e.preventDefault(); setOpen(o => !o); }}
        aria-label={title}
        data-tooltip={title}
        data-tooltip-placement="top"
      >
        {mainIconName && (
          <Icon icon={mainIconName} className={`icon ${[mainIconName, ...mainIconClasses].join(' ')}`} />
        )}
        <Icon icon={open ? 'caret-up-fill' : 'caret-down-fill'} className="icon caretIcon small" />
      </button>

      {open && (
        <ContextMenu
          items={menuItems}
          triggerRef={triggerRef}
          onClose={() => setOpen(false)}
          placement="above"
          inline={false}
        />
      )}
    </div>
  );

  return btn;
}
